import React, { useEffect, useState } from 'react'
import robotImg from '../../images/robotImg.png'
import toast from 'react-hot-toast';
import { useLanguage } from '../../Providers/LanguageContext';
import HttpClient from '../../utils/HttpClient';
import { useUserData } from '../../Providers/UserWrapper';
import Users from "../../View/Users/Index";

const PopupTwo = ({ onClose, onNext }) => {
  // Add this state
  const [showUserModal, setShowUserModal] = useState(false);
  const initValue = {
    "typeId": "",
    "file": "",
    "documentName": ""
  }
  const [formValue, setFormValue] = useState(initValue);
  const { setIsLoading } = useUserData();
  const [typeData, setTypeData] = useState([]);
  const { language, currentLanguage } = useLanguage();
  const [uploadedFileName, setUploadedFileName] = useState("");

  // handleChange
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue(prev => ({ ...prev, [name]: value }));
  };

  // handle change file
  const handlePdfUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check file type (allow PDF and common image types)
      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
      if (!allowedTypes.includes(file.type)) {
        toast.error("Please upload a PDF, JPEG, or PNG file");
        return;
      }

      // Check file size (max 10MB)
      const maxSize = 10 * 1024 * 1024; // 10MB in bytes
      if (file.size > maxSize) {
        toast.error("File size too large. Maximum size is 10MB");
        return;
      }

      const data = new FormData();
      data.append("document", file);
      setIsLoading(true);

      try {
        const res = await HttpClient.fileUplode("upload/selfservice-document", "POST", data);
        setIsLoading(false);

        if (res && res.status) {
          setFormValue(prev => ({
            ...prev,
            documentName: res?.originalname,
            file: res?.url
          }));
          setUploadedFileName(res?.originalname || file.name);
          toast.success("Uploaded Successfully!");
        } else {
          toast.error(res?.message || "Upload failed");
        }
      } catch (error) {
        setIsLoading(false);
        toast.error("Upload failed. Please try again.");
      }
    }
  }

  // get all type
  const getAllType = async () => {
    const data = {
      "language": currentLanguage === "eng" ? "EN" : "ES"
    }
    try {
      const res = await HttpClient.requestData("view/importdocument", "GET", data);
      if (res && res?.status) {
        // Sort the array of objects alphabetically by 'name_EN' for English or 'name_ES' for Spanish
        const sortedData = res.data.sort((a, b) => {
          const nameA = currentLanguage === "eng" ? a.name_EN.toLowerCase() : a.name_ES.toLowerCase();
          const nameB = currentLanguage === "eng" ? b.name_EN.toLowerCase() : b.name_ES.toLowerCase();
          return nameA.localeCompare(nameB);
        });

        // Set the sorted data to state
        setTypeData(sortedData);
      } else {
        toast.error("Failed to fetch types");
      }
    } catch (error) {
      console.error("Error fetching types:", error);
      toast.error("Error fetching types");
    }
  };

  // Clear uploaded file
  const clearFile = () => {
    setFormValue(prev => ({ ...prev, file: "", documentName: "" }));
    setUploadedFileName("");
    toast.success("File removed");
  };

  // Clear selected type
  const clearType = () => {
    setFormValue(prev => ({ ...prev, typeId: "" }));
  };

  // validation
  const validate = () => {
    if (!formValue.typeId) {
      toast.error("Please Select a Type");
      return true;
    }

    if (!formValue.file) {
      toast.error("Please Choose a File");
      return true;
    }

    return false;
  }

  // handle import
  const handleImport = async (e) => {
    e.preventDefault();
    if (validate()) {
      return;
    }

    setIsLoading(true);
    try {
      const res = await HttpClient.requestData("add/selfservice-document", "POST", formValue);
      setIsLoading(false);

      if (res && res?.status) {
        setFormValue(initValue);
        setUploadedFileName("");
        toast.success("Document Imported Successfully!");
        onNext(); // Move to next step after successful import
      } else {
        toast.error(res?.message || "Something went wrong");
      }
    } catch (error) {
      setIsLoading(false);
      toast.error("Failed to import document");
    }
  }

  // Handle save and next
  const handleSaveAndNext = async (e) => {
    await handleImport(e);
  };

  // Handle skip to next
  const handleSkipNext = () => {
    // Clear any existing form data when skipping
    setFormValue(initValue);
    setUploadedFileName("");
    onNext();
  };

  useEffect(() => {
    getAllType();
  }, [currentLanguage]); // Add currentLanguage as dependency to refetch when language changes

  return (
    <div className="popup_overlay_po" onClick={onClose}>
      <div
        className="popup_container_po"
        onClick={(e) => e.stopPropagation()}
      >

        <div className="popup_content_po">

          <div className="popup_left_po">

            <div className="mob_rob_wrp">
              <h2 className='extra_h2_st'>
                The System Runs On Data. Let's Get It Running For You!
              </h2>
              <div className="robo_img_wrp">
                <img src={robotImg} alt="" />
              </div>
            </div>

            <div className="step_pill_po">Step 2 : Ignite</div>

            <p className="upload_label">Select Document Type</p>
            <div className="upload_box_po">
              <div className="upload_inner_po">
                <select
                  className="form-control"
                  name='typeId'
                  value={formValue.typeId}
                  onChange={e => handleChange(e)}
                  style={{
                    background: '#0c2637',
                    border: 'none',
                    color: '#fff',
                    height: '45px',
                    width: '100%',
                    padding: '0 10px'
                  }}
                >
                  <option style={{
                    color: '#0c2637',
                    background: '#fff'
                  }} disabled value={""}>-Select-</option>
                  {
                    typeData?.map((item, i) =>
                      <option style={{
                        color: '#0c2637',
                        background: '#fff'
                      }} key={i} value={item?._id}>
                        {currentLanguage === "eng" ? item?.name_EN : item?.name_ES}
                      </option>
                    )
                  }
                </select>
              </div>
              {formValue.typeId && (
                <i
                  className="fa-solid fa-trash upload_trash_po"
                  onClick={clearType}
                  style={{ cursor: 'pointer' }}
                  title="Clear selection"
                ></i>
              )}
            </div>

            <p className="upload_label">Upload Data Files (System will process files in 72 hours or less)</p>
            <div className="upload_box_po">
              <div className="upload_inner_po">
                <input
                  type="file"
                  id="fileUpload"
                  style={{ display: 'none' }}
                  onChange={handlePdfUpload}
                  accept=".pdf,.jpg,.jpeg,.png"
                />
                <label
                  htmlFor="fileUpload"
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    width: '100%',
                    justifyContent: 'center'
                  }}
                >
                  <i className="fa-solid fa-cloud-arrow-up"></i>
                  <span>BROWSE</span>
                </label>
                {uploadedFileName && (
                  <div style={{
                    marginTop: '10px',
                    fontSize: '12px',
                    color: '#4CAF50',
                    textAlign: 'center',
                    wordBreak: 'break-word'
                  }}>
                    ✓ {uploadedFileName}
                  </div>
                )}
              </div>
              {formValue.file && (
                <i
                  className="fa-solid fa-trash upload_trash_po"
                  onClick={clearFile}
                  style={{ cursor: 'pointer' }}
                  title="Remove file"
                ></i>
              )}
            </div>
            <p className="upload_label">Setup My Users (Welcome Mail will automatically be sent to your users)</p>
            <div className="upload_box_po">
              <div className="upload_inner_po">
                <button
                  className="btn"
                  style={{
                    background: '#0c2637',
                    border: 'none',
                    color: '#fff',
                    height: '45px',
                    width: '100%',
                    padding: '0 10px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  onClick={() => setShowUserModal(true)}
                >
                  Open User Management
                </button>
              </div>
            </div>


            <button className="save_next_po" onClick={handleSaveAndNext}>
              SAVE & NEXT
            </button>

            <p className="skip_po" onClick={handleSkipNext}>
              Skip to next
            </p>
          </div>
        </div>
      </div>
      <div className="popup_right_po">
        <img
          src={robotImg}
          alt="robot"
          className="robot_img_po"
        />
      </div>

      {showUserModal && (
        <div
          style={{
            position: 'fixed',
            top: 5,
            left: 0,
            right: 0,
            bottom: 0,
            background: '#122739',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: "none",
          }}
          onClick={() => setShowUserModal(false)}
        >
          <div
            style={{
              background: '#fff',
              borderRadius: '10px',
              width: '95%',
              maxWidth: '1200px',
              height: '95%',
              overflow: 'auto',
              position: 'relative'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowUserModal(false)}
              style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                background: '#ff4444',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '30px',
                height: '30px',
                cursor: 'pointer',
                zIndex: 10000
              }}
            >
              ×
            </button>
            <Users />
          </div>
        </div>
      )}
    </div>
  )
}

export default PopupTwo;